import {
  createStore
} from 'vuex'
import leftAside from './modules/leftAside'
import topNavTag from './modules/topNavTag'
import routes from './modules/routes'
import user from './modules/user'
import skuBaseData from './modules/skuBaseData'
import lcJxStore from './modules/lcJxStore'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    leftAside,
    topNavTag,
    routes,
    user,
    skuBaseData,
    lcJxStore
  }
})
